import type { RootState } from "@/types";
import type { Intervention } from "@/types/bexSupport";
import type { InterventionState } from "@/types/store";
import type { GetterTree } from "vuex";

export const getters: GetterTree<InterventionState, RootState> = {
  getInterventions(state): Intervention[] {
    return state.interventions.data;
  },
  getCompletedInterventions(state): Intervention[] {
    return state.interventions.data_completed;
  },
  getInterventionsCount(state): number {
    return state.interventions.count;
  },
  getCompletedInterventionsCount(state): number {
    return state.interventions.count_completed;
  },
  getInterventionsLoading(state): boolean {
    return state.interventions.loading;
  },
  getInterventionsError(state): string | null {
    return state.interventions.error;
  },
  getIntervention(state): Intervention {
    return state.intervention.data;
  },
};
